import GradientBorderRadius from "@/ui/gradient-border-radius";
import TermsOfServiceHeader from "./terms-of-service-header";

const TermsOfService = () => {
  return (
    <GradientBorderRadius
      background="section-gradient"
      overflow
      className="flex-1 flex w-full"
    >
      <div className="flex-1 flex flex-col w-full gap-[0.625rem] pt-[0.625rem]">
        <TermsOfServiceHeader />
        <div className="h-full w-full px-[0.625rem] overflow-auto custom-scrollbar">
          <p className="text-xs">
            Please read these Terms of Service (the “Terms”) and our Privacy
            Policy (“Privacy Policy”) carefully because they govern your use of
            the website and interface located at https://arkaine.ai (the “Site”
            or the “Arkaine Platform”), enabled or offered by Maitrix Limited
            (“Maitrix” “we,” “our”), which facilitates interaction with certain
            decentralized cryptographic protocols and offerings, which are
            either open-sourced or may become open-sourced (collectively, the
            “Protocols”) to provide you with learning processes, token screener
            charts, and advanced trading charts/bots for you to choose from
            (“Arkaine Platform”). To make these Terms easier to read, the Site,
            software, Apps and our Arkaine Platform services are collectively
            called the “Services”. These Terms do not govern any interactions
            you may have with our third-party API providers, if any, each of
            which has its own terms. Maitrix is not a bank or financial
            institution and does not provide investment or financial advice to
            users of the Services. We are solely the provider of the Services.
            <br />
            <br />
            PLEASE REVIEW CAREFULLY SECTION 16 “DISPUTE RESOLUTION” BELOW FOR
            DETAILS REGARDING LITIGATION.
            <br />
            <br />
            1. Agreement to Terms. By using the Services, you agree to be bound
            by these Terms. If you don’t agree to be bound by these Terms, you
            are not authorized to use the Services.
            <br />
            <br />
            2. Privacy Policy. Please review our Privacy Policy, which also
            governs your use of the Services, for information on how we collect,
            use and share your information.
            <br />
            <br />
            3. Changes to these Terms or the Services. We may update the Terms
            from time to time at our sole discretion. If we do, we’ll let you
            know by posting the updated Terms on the Site, to the Apps and/or
            may also send other communications. It’s important that you review
            the Terms whenever we update them, or you use the Services. If you
            continue to use the Services after we have posted updated Terms, it
            means that you accept and agree to the changes. If you don’t agree
            to be bound by the changes, you may not use the Services anymore.
            Because the Services are evolving over time, we may change or
            discontinue all or any part of the Services, at any time and without
            notice, at our sole discretion.
            <br />
            <br />
            4. Who May Use the Services?
            <br />
            <br />
            (a) Eligibility. YOU MAY USE THE SERVICES ONLY IF YOU ARE 18 YEARS
            OR OLDER AND CAPABLE OF FORMING A BINDING CONTRACT WITH MAITRIX, AND
            NOT OTHERWISE BARRED FROM USING THE SERVICES UNDER APPLICABLE LAW.
            We will not knowingly solicit or collect personal information from
            any user under the age of 13. Do not attempt to use the Services if
            you are under the age of 13. If we become aware that a user is under
            the age of 13, we will promptly delete all personal information of
            the user. If you have information that suggests that a user of the
            Service could be under the age of 13, please send an email to
            team@arkaine.io.
            <br />
            <br />
            (b) Compliance. The Services are only available to users in certain
            jurisdictions who can use the Services as permitted under applicable
            law. You certify that you will comply with all applicable laws
            (e.g., local, state, federal and other laws) when using the
            Services. Without limiting the foregoing, by using the Services, you
            represent and warrant that: (a) you are not located in a country
            that is subject to a U.S. Government embargo; and (b) you are not
            listed on any U.S. Government list of prohibited, sanctioned, or
            restricted parties. If you access or use the Services outside the
            United States, you are solely responsible for ensuring that your
            access and use of the Services in such country, territory or
            jurisdiction does not violate any applicable laws. You must not use
            any software or networking techniques, including use of a Virtual
            Private Network (VPN) to modify your internet protocol address or
            otherwise circumvent or attempt to circumvent this prohibition. We
            reserve the right, but have no obligation, to monitor where the
            Services are accessed from. Furthermore, we reserve the right, at
            any time, at our sole discretion, to block access to the Services,
            in whole or in part, from any geographic location, IP addresses and
            unique device identifiers or to any user who we believe is in breach
            of these Terms.
            <br />
            <br />
            (c) Unauthorized Access. You may not access or utilize the Site
            and/or Services for the purpose of web crawling, web harvesting,
            data mining, data extraction, scraping or aggregating information,
            including without limitation listings and smart contracts available
            on or through the Site and/or Services, or similar activities
            without our prior written consent at our sole discretion. We reserve
            the right to implement testing and maintenance of the application
            programming interface (“API”) at our sole discretion. Engaging in
            any of the activities referenced in the first sentence of this
            paragraph without prior authorization is a prohibited material
            breach of these Terms and may subject violators to legal liability.
            <br />
            <br />
            5. About the Services.
            <br />
            <br />
            (a) The Arkaine Platform. The Services facilitate interactions with
            the Protocols and Blockchains to allow individuals to, inter alia,
            purchase, facilitate their trades, and use the Services on the
            Arkaine Platform. Maitrix provides the Arkaine Platform, which is an
            interface to interact with the Protocols and other Blockchains
            offerings.
            <br />
            <br />
            (i) You may participate in the Services by linking your digital
            wallet(s) to supported bridge extensions, which allows you to
            purchase, store, and engage in transactions using cryptocurrency.
            Before using our Services, we will ask you to download a supported
            electronic wallet extension and connect and unlock your digital
            wallets with that extension. By doing so you would be able to
            utilize any of the offered Services and interact with the offered
            facilities within Arkaine Platform.
            <br />
            <br />
            (ii) ARKAINE PLATFORM IS NOT A BROKER, FINANCIAL INSTITUTION, OR
            CREDITOR. THE SERVICES ARE AN ADMINISTRATIVE PLATFORM ONLY. MAITRIX
            FACILITATES TRANSACTIONS BETWEEN THE USERS IF ANY OF THE THIRD-PARTY
            SERVICE PROVIDER ON THE ARKAINE PLATFORM BUT IS NOT A PARTY TO ANY
            AGREEMENT BETWEEN THE USERS THE THIRD-PARTY SERVICE PROVIDER OF THE
            SERVICES OR BETWEEN ANY USERS.
            <br />
            <br />
            (iii) YOU BEAR FULL RESPONSIBILITY FOR VERIFYING THE IDENTITY,
            LEGITIMACY, AND AUTHENTICITY OF ASSETS YOU PURCHASE OR UTILIZE
            THROUGH THE ARKAINE PLATFORM. NOTWITHSTANDING INDICATORS AND
            MESSAGES THAT SUGGEST VERIFICATION, MAITRIX MAKES NO CLAIMS ABOUT
            THE IDENTITY, LEGITIMACY, OR AUTHENTICITY OF ANY ASSETS ON THE
            ARKAINE PLATFORM.
            <br />
            <br />
            (b) Transactions Are Conducted on the Blockchain. While Maitrix
            offers Arkaine Platform for the Services, it does not buy, sell or
            take custody or possession of any of the Services, nor does it act
            as an agent or custodian for any user of the Services. Instead, each
            Service that is listed will be managed via a blockchain-based smart
            contract deployed by Maitrix to ensure that the purported user fully
            profit from the use of such Service. Each or some of the Services
            utilization are managed through the relevant Blockchain network. You
            will be required to make or receive payments through the
            cryptocurrency wallet you have connected to the Arkaine Platform. We
            will have no insight into or control over these payments or
            transactions, nor do we have the ability to reverse any
            transactions. Accordingly, we will have no liability to you or to
            any third party for any claims or damages that may arise because of
            any transactions that you engage in via the Service. The smart
            contract shall deduct any fees owed to the Arkaine Platform whenever
            a transaction is executed.
            <br />
            <br />
            (c) Promotions Programs and other additions to the Platform. Your
            participation in certain programs (e.g., promotions, sweepstakes,
            giveaways, contests, rewards programs, etc.) or additional features
            made available through the Arkaine Platform will be subject to
            additional terms and conditions specific to such programs as set
            forth by Maitrix or the sponsor of each promotion or program.
            <br />
            <br />
            (d) Terms Applicable to Arkaine Platform users. You agree to the
            following additional terms: Users Terms. Although the terms for the
            Services are displayed on the Arkaine Platform, all such terms are
            determined by the users and the Services are subject to such (e.g.,
            with respect to the use of the Services Content, as defined below in
            Section 5(d)(ii), or benefits associated with a given Service)
            (“Users Terms”), including, but not limited to, the price to be paid
            for such Services. Maitrix is not a party to any such purchase
            Terms, assuming a third party service provider is offering such
            service which are solely between the user and the service provider
            and is not responsible for ensuring compliance with such terms or
            mediating or resolving any disputes with respect to such Users
            Terms, including, but not limited to, any disputes arising out of or
            related to the authenticity of the Services or any intellectual
            property rights associated with such Services. The user and service
            provider, if any, are entirely responsible for communicating,
            promulgating, agreeing to, and enforcing Users Terms, and for
            resolving any disputes arising from any breach of any Users Terms.
            Seller must comply with and fulfill the User Terms with respect to
            any Services that it sells. When you purchase Services through the
            Platform, you own all personal property rights to the electronic
            record that comprises the Services (i.e., the right to sell or
            otherwise dispose of that Services) to the extent permitted by the
            service provider. Unless expressly specified in the Users Terms,
            such rights, however, do not include the ownership of the
            intellectual property rights in any Service Content.
            <br />
            <br />
            (i) Costs and Fees. Transactions on the Arkaine Platform may be
            subject to fees that Maitrix collects to support the Services and
            Arkaine Platform, as posted on the Site or otherwise set forth in
            these Terms. “Revenue” means the gross amount collected for
            providing our Services on the Arkaine Platform. You further agree to
            pay all other applicable fees, including Gas Fees and hosting fees,
            and you authorize Maitrix to automatically charge you for any such
            fees or deduct such fees (including the Transaction Fee) directly
            from the amounts paid by You or the amount received by a service
            provider, if any, at our discretion. The payments made do not
            include any Taxes (as defined below), and Maitrix shall have no
            responsibility for payment of such Taxes regardless of the taxing
            authority. Each party shall be responsible for all Taxes imposed on
            its income or property. Users will be responsible for paying all
            such fees, Taxes, and Gas fees. In addition, interactions with the
            Blockchain may also result in transaction fees or Gas Fees (as
            defined below) being imposed by the Blockchain, which are also
            solely your responsibility. “Gas fees” mean fees that fund the
            network of computers that run decentralized blockchain networks,
            meaning that you will need to pay a Gas Fee for each transaction
            that occurs via a blockchain network.
            <br />
            <br />
            (ii) Revenue and Fees. Arkaine will receive Revenue and the
            Transaction Fee for each initial utilization of the Services on the
            Arkaine Platform. “Transaction Fee” means the percentage of the
            Revenue generated from utilizing the Services that are listed on the
            Arkaine Platform, as agreed by You, when utilizing the Services. The
            Transaction Fee may be, but is not required to be, the sale
            percentage for all sales of Services and may be changed from time to
            time prior to being agreed to on the listing interface.
            <br />
            <br />
            (e) Terms Applicable to the Software. Use of the Software is
            governed by these Terms. Maitrix delivers the Software via
            download/API integration and we will not provide you with any
            tangible copy of the Software. Subject to your compliance with the
            Terms, Maitrix grants you a non-assignable, non-transferable,
            non-sublicensable, revocable, and non-exclusive license to use the
            Software on computers or mobile devices you own or control solely
            for your personal or internal business purposes. Because the
            Software is locally installed, you are responsible for the security
            of the device on which it is installed, including ensuring that you
            keep anti-virus software current and otherwise protect the device on
            which the Software is installed against malware. You are responsible
            for securely maintaining any passwords or secret phrases that relate
            to your use of the Software or any other platform you use via
            Arkaine Platform. You acknowledge that certain methods of securing a
            secret recovery phrase, such as storing it as a digital file on your
            personal device or on a cloud storage provider, may increase the
            risk that your account or secret recovery phrase will be
            compromised. You further acknowledge that Maitrix is not responsible
            for any theft of a secret recovery phrase, or loss or damages –
            including loss of funds or lockout from accounts accessed via the
            Software – resulting from your failure to keep the device on which
            the Software is installed safe and free of any malware. Maitrix may
            not be able to recover passwords or unlock account information
            stored on the Software, including if the Software is compromised by
            malware on your computer, and it is your sole responsibility to take
            all reasonable precautions to secure and backup your copy of the
            Software and the information stored on it.
            <br />
            <br />
            (f) Updates. The Software and Services are evolving, and you may be
            required to accept or install updates to the Software or Services,
            or update third-party software (i.e., browsers or OS) in order to
            keep using the Software or Services or access their latest features,
            including security updates. We may update the Software and Services
            at any time, without providing notice. It is your responsibility to
            ensure that you are using the most recent version of the Software at
            all times.
            <br />
            <br />
            (g) Price Alerts. By using a price alerts feature, you agree that
            price alerts are for informational purposes only. Price alerts may
            be delayed, limited or inaccurate and may not cover all assets.
            Maitrix is not responsible for any customer losses caused by price
            alerts.
            <br />
            <br />
            (h) Taxes. You are solely responsible for all costs incurred by you
            in using the Services and determining, collecting, reporting and
            paying all applicable Taxes. As used herein, “Taxes” means the
            taxes, duties, levies, tariffs, and other governmental charges that
            you may be required by law to collect and remit to governmental
            agencies, and other similar municipal, state, federal and national
            indirect or other withholding and personal or corporate income
            taxes. You are solely responsible for maintaining all relevant Tax
            records and complying with any reporting requirements you may have
            as related to the Services. You are further solely responsible for
            independently maintaining the accuracy of any record submitted to
            any tax authority including any information derived from the
            Services. We reserve the right to report any activity occurring
            using the Services to relevant tax authorities as required under
            applicable law.
            <br />
            <br />
            (i) Suspension or Termination. We may suspend or terminate your
            access to the Services at any time in connection with any
            transaction as required by applicable law, any governmental
            authority, or if we at our sole and reasonable discretion determine
            you are violating these Terms or the terms of any third-party
            service provider. Such suspension or termination shall not
            constitute a breach of these Terms by Maitrix. In accordance with
            our anti-money laundering, anti-terrorism, anti-fraud, and other
            compliance policies and practices, we may impose reasonable
            limitations and controls on the ability of you or any beneficiary to
            utilize the Services. Such limitations may include where good cause
            exists, rejecting transaction requests, freezing funds, or otherwise
            restricting you from using the Services.
            <br />
            <br />
            6. Feedback. We appreciate feedback, comments, ideas, proposals and
            suggestions for improvements to the Services (“Feedback”). If you
            choose to submit Feedback, you agree that we are free to use it
            without any restriction or compensation to you.
            <br />
            <br />
            7. Rights and Terms for Apps. App License. If you comply with these
            Terms, Maitrix grants you a limited non- exclusive, non-transferable
            license, with no right to sublicense, to download and install Apps
            on your personal computers, mobile handsets, tablets, wearable
            devices, and/or other devices and to run Apps solely for your own
            personal non-commercial purposes. Except as expressly permitted in
            these Terms, you may not: (i) copy, modify or create derivative
            works based on the Apps; (ii) distribute, transfer, sublicense,
            lease, lend or rent the Apps to any third party; (iii) reverse
            engineer, decompile or disassemble the Apps (unless applicable law
            permits, despite this limitation); or (iv) make the functionality of
            the App available to multiple users through any means.Acceptable Use
            Policy and Maitrix’ Enforcement Rights. You agree not to do any of
            the following:
            <br />
            <br />
            (a) Post, upload, publish, submit or transmit any User Content that:
            (i) infringes, misappropriates or violates a third party’s patent,
            copyright, trademark, trade secret, moral rights or other
            intellectual property rights, or rights of publicity or privacy;
            (ii) violates, or encourages any conduct that would violate, any
            applicable law or regulation or would give rise to civil liability;
            (iii) is fraudulent, false, misleading or deceptive; (iv) is
            defamatory, obscene, pornographic, vulgar or offensive; (v) promotes
            discrimination, bigotry, racism, hatred, harassment or harm against
            any individual or group; (vi) is violent or threatening or promotes
            violence or actions that are threatening to any person or entity; or
            (vii) promotes illegal or harmful activities or substances;
            <br />
            <br />
            (b) Use, display, mirror or frame the Services or any individual
            element within the Services, Maitrix’ name, any Maitrix trademark,
            logo or other proprietary information, or the layout and design of
            any page or form contained on a page, without Maitrix’ express
            written consent;
            <br />
            <br />
            (c) Access, tamper with, or use non-public areas of the Services,
            Maitrix’ computer systems, or the technical delivery systems of
            Maitrix’ providers;
            <br />
            <br />
            (d) Attempt to probe, scan or test the vulnerability of any Maitrix
            system or network or breach any security or authentication measures;
            <br />
            <br />
            (e) Avoid, bypass, remove, deactivate, impair, descramble or
            otherwise circumvent any technological measure implemented by
            Maitrix or any of Maitrix’ providers or any other third party
            (including another user) to protect the Services;
            <br />
            <br />
            (f) Attempt to access or search the Services or download content
            from the Services using any engine, software, tool, agent, device or
            mechanism (including spiders, robots, crawlers, data mining tools or
            the like) other than the software and/or search agents provided by
            Maitrix or other generally available third-party web browsers;
            <br />
            <br />
            (g) Send any unsolicited or unauthorized advertising, promotional
            materials, email, junk mail, spam, chain letters or other form of
            solicitation;
            <br />
            <br />
            (h) Use the Services, or any portion thereof, for any commercial
            purpose or for the benefit of any third party or in any manner not
            permitted by these Terms;
            <br />
            <br />
            (i)Forge any TCP/IP packet header or any part of the header
            information in any email or newsgroup posting, or in any way use the
            Services to send altered, deceptive or false source- identifying
            information;
            <br />
            <br />
            (j) Attempt to decipher, decompile, disassemble or reverse engineer
            any of the software used to provide the Services;
            <br />
            <br />
            (k) Interfere with, or attempt to interfere with, the access of any
            user, host or network, including, without limitation, sending a
            virus, overloading, flooding, spamming, or mail- bombing the
            Services;
            <br />
            <br />
            (l) Collect or store any personally identifiable information from
            the Services from other users of the Services without their express
            permission;
            <br />
            <br />
            (m) Impersonate or misrepresent your affiliation with any person or
            entity;
            <br />
            <br />
            (n) Create or list counterfeit items;
            <br />
            <br />
            (o) Engage or assist in any activity that violates any law, statute,
            ordinance, regulation, or sanctions program, including but not
            limited to the U.S. Department of Treasury’s Office of Foreign
            Assets Control (“OFAC”), or that involves proceeds of any unlawful
            activity (including but not limited to money laundering, terrorist
            financing or deliberately engaging in activities designed to
            adversely affect the performance of the Services);
            <br />
            <br />
            (p) Use the Services to participate in fundraising for a business,
            protocol, or platform, including but not limited to creating,
            listing, or buying assets that are redeemable for financial
            instruments, assets that give owners the rights to participate in
            any securities offering, or assets that entitle owners to financial
            rewards, including but not limited to, DeFi (or decentralized
            finance) yield bonuses, staking bonuses, and burn discounts;
            <br />
            <br />
            (q) Fabricate in any way any transaction or process related thereto;
            <br />
            <br />
            (r) Place misleading bids or offers;
            <br />
            <br />
            (s) Disguise or interfere in any way with the IP address of the
            computer you are using to access or use the Services or that
            otherwise prevents us from correctly identifying the IP address of
            the computer you are using to access the Services;
            <br />
            <br />
            (t) Transmit, exchange, or otherwise support the direct or indirect
            proceeds of criminal or fraudulent activity;
            <br />
            <br />
            (u) Violate any applicable law or regulation; or
            <br />
            <br />
            (v) Encourage or enable any other individual to do any of the
            foregoing. Maitrix is not obligated to monitor access to or use of
            the Services or to review or edit any content. However, we have the
            right to do so for the purpose of operating the Services, to ensure
            compliance with these Terms and to comply with applicable law or
            other legal requirements. We reserve the right, but are not
            obligated, to remove or disable access to any content, including
            user content, at any time and without notice, including, but not
            limited to, if we, at our sole discretion, consider it objectionable
            or in violation of these Terms. We have the right to investigate
            violations of these Terms or conduct that affects the Services. We
            may also consult and cooperate with law enforcement authorities to
            prosecute users who violate the law. The sale of stolen assets,
            assets taken without authorization, and otherwise illegally obtained
            assets on the Service is prohibited. If you have reason to believe
            that an asset listed on the Service was illegally obtained, please
            contact us immediately. Listing illegally obtained assets may result
            in your listings being canceled, your assets being hidden, or you
            being suspended from the Services.
            <br />
            <br />
            8. Copyright Policy. Maitrix respects copyright law and expects its
            users to do the same. It is Maitrix’ policy to terminate in
            appropriate circumstances users who repeatedly infringe or are
            believed to be repeatedly infringing the rights of copyright
            holders.
            <br />
            <br />
            9. Links to Third Party Websites or Resources. The Services
            (including the Apps) may allow you to access third-party websites or
            other resources. We provide access only as convenience and are not
            responsible for the content, products or services on or available
            from those resources, websites, or links displayed on such resources
            or websites. You acknowledge sole responsibility for and assume all
            risk arising from your use of any third-party resources or websites.
            <br />
            <br />
            10. Termination. Notwithstanding anything contained in these Terms,
            we may suspend, modify or terminate your access to and use of the
            Services and the applicability of these Terms at our sole
            discretion, at any time and without notice to you. You may
            disconnect your digital wallet at any time. You acknowledge and
            agree that we shall have no liability or obligation to you in such
            an event and that you will not be entitled to a refund of any
            amounts that you have already paid to us or any third party, to the
            fullest extent permitted by applicable law. Upon any termination,
            discontinuation or cancellation of the Services, the following
            Sections will survive: 5(d)(ii) and 5(e)(i) (only for payments due
            and owing to Maitrix prior to the termination), 7(b), 7(c), 7(e), 9,
            12, 13, 15, 16, 17, 18 and 19. <br />
            <br />
            11. Warranty Disclaimers. THE SERVICES, INCLUDING THE SOFTWARE,
            PROMOTIONS TOOL, ANY CONTENT CONTAINED THEREIN, AND ANY SERVICES
            (INCLUDING ASSOCIATED SERVICE CONTENT) LISTED THEREIN ARE PROVIDED
            ON AN “AS IS” AND “AS AVAILABLE” BASIS WITHOUT WARRANTIES OR
            CONDITIONS OF ANY KIND, EITHER EXPRESS OR IMPLIED. MAITRIX (AND ITS
            SUPPLIERS) MAKE NO WARRANTY THAT THE SERVICES: (I) WILL MEET YOUR
            REQUIREMENTS; (II) WILL BE AVAILABLE ON AN UNINTERRUPTED, TIMELY,
            SECURE, OR ERROR-FREE BASIS; OR (III) WILL BE ACCURATE, RELIABLE,
            COMPLETE, LEGAL, OR SAFE. MAITRIX DISCLAIMS ALL OTHER WARRANTIES OR
            CONDITIONS, EXPRESS OR IMPLIED, INCLUDING, WITHOUT LIMITATION,
            INCLUDING ANY IMPLIED WARRANTY OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE, QUIET ENJOYMENT OR NON-INFRINGEMENT, TO THE
            MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, AS TO THE SERVICES, ANY
            CONTENT CONTAINED THEREIN AND ANY NFTS LISTED THEREIN. WE FURTHER
            EXPRESSLY DISCLAIM ALL LIABILITY OR RESPONSIBILITY IN CONNECTION
            WITH THIRD PARTY SERVICES. NOTHING HEREIN NOR ANY USE OF THE
            SERVICES IN CONNECTION WITH THIRD PARTY SERVICES CONSTITUTES OUR
            ENDORSEMENT, RECOMMENDATION OR ANY OTHER AFFILIATION OF OR WITH ANY
            THIRD-PARTY SERVICES. MAITRIX DOES NOT REPRESENT OR WARRANT THAT ANY
            CONTENT ON THE SERVICES IS ACCURATE, COMPLETE, RELIABLE, CURRENT OR
            ERROR-FREE. WE WILL NOT BE LIABLE FOR ANY LOSS OF ANY KIND FROM ANY
            ACTION TAKEN OR TAKEN IN RELIANCE ON MATERIAL OR INFORMATION
            CONTAINED ON THE SERVICES. WHILE MAITRIX ATTEMPTS TO MAKE YOUR
            ACCESS TO AND USE OF THE SERVICES AND ANY CONTENT THEREIN SAFE,
            MAITRIX CANNOT AND DOES NOT REPRESENT OR WARRANT THAT THE SERVICES,
            ANY CONTENT THEREIN, ANY NFTS LISTED THEREIN, OR OUR SERVERS ARE
            FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. WE CANNOT GUARANTEE THE
            SECURITY OF ANY DATA THAT YOU DISCLOSE ONLINE. YOU ACCEPT THE
            INHERENT SECURITY RISKS OF PROVIDING INFORMATION AND DEALING ONLINE
            OVER THE INTERNET AND WILL NOT HOLD US RESPONSIBLE FOR ANY BREACH OF
            SECURITY. MAITRIX WILL NOT BE RESPONSIBLE OR LIABLE TO YOU FOR ANY
            LOSS AND TAKES NO RESPONSIBILITY FOR, AND WILL NOT BE LIABLE TO YOU
            FOR, ANY USE OF THE SERVICES, INCLUDING BUT NOT LIMITED TO ANY
            LOSSES, DAMAGES OR CLAIMS ARISING FROM: (I) USER ERROR SUCH AS
            FORGOTTEN PASSWORDS, INCORRECTLY CONSTRUCTED TRANSACTIONS, OR
            MISTYPED WALLET ADDRESSES; (II) SERVER FAILURE OR DATA LOSS; (III)
            BLOCKCHAIN NETWORKS, CRYPTOCURRENCY WALLETS OR CORRUPT FILES; (IV)
            UNAUTHORIZED ACCESS TO SERVICES; OR (V) ANY THIRD PARTY ACTIVITIES,
            INCLUDING WITHOUT LIMITATION THE USE OF VIRUSES, PHISHING,
            BRUTEFORCING OR OTHER MEANS OF ATTACK. YOU BEAR FULL RESPONSIBILITY
            FOR VERIFYING THE IDENTITY, LEGITIMACY, AND AUTHENTICITY OF ASSETS
            YOU PURCHASE RENT OR USE THROUGH THE SERVICES. NOTWITHSTANDING
            INDICATORS AND MESSAGES THAT SUGGEST VERIFICATION, MAITRIX MAKES NO
            CLAIMS ABOUT IDENTITY, LEGITIMACY, OR AUTHENTICITY OF ASSETS ON THE
            SERVICES.THE SERVICES MAY NOT BE AVAILABLE DUE TO ANY NUMBER OF
            FACTORS INCLUDING, BUT NOT LIMITED TO, PERIODIC SYSTEM MAINTENANCE,
            SCHEDULED OR UNSCHEDULED, ACTS OF GOD, UNAUTHORIZED ACCESS, VIRUSES,
            DENIAL OF SERVICE OR OTHER ATTACKS, TECHNICAL FAILURE OF THE
            SERVICES AND/OR TELECOMMUNICATIONS INFRASTRUCTURE OR DISRUPTION, AND
            THEREFORE WE EXPRESSLY DISCLAIM ANY EXPRESS OR IMPLIED WARRANTY
            REGARDING THE USE AND/OR AVAILABILITY, ACCESSIBILITY, SECURITY OR
            PERFORMANCE OF THE SERVICES CAUSED BY SUCH FACTORS. WE DO NOT MAKE
            ANY REPRESENTATIONS OR WARRANTIES AGAINST THE POSSIBILITY OF
            DELETION, MISDELIVERY OR FAILURE TO STORE COMMUNICATIONS,
            PERSONALIZED SETTINGS OR OTHER DATA.SOME JURISDICTIONS DO NOT ALLOW
            THE EXCLUSION OF CERTAIN WARRANTIES. ACCORDINGLY, SOME OF THE ABOVE
            DISCLAIMERS OF WARRANTIES MAY NOT APPLY TO YOU.
            <br />
            <br />
            12. Assumption of Risk. You accept and acknowledge:
            <br />
            <br />
            (a) The prices and liquidity of cryptocurrency assets are extremely
            volatile. Fluctuations in the price of other digital assets could
            materially and adversely affect the Services made available through
            the Platform, which may also be subject to significant price
            volatility.
            <br />
            <br />
            (b) You are solely responsible for determining what, if any, Taxes
            apply to your transactions through the Services. Neither Maitrix nor
            any Maitrix affiliates are responsible for determining the Taxes
            that apply to such transactions.
            <br />
            <br />
            (c) Any transfer of cryptocurrency assets occurs within the
            supporting Blockchain and not on the Services. Transactions may be
            irreversible, and, accordingly, losses due to fraudulent or
            accidental transactions may not be recoverable. Some transactions
            should be deemed to be made when recorded on a public ledger, which
            is not necessarily the date or time that you initiated the
            transaction.
            <br />
            <br />
            (d) There are risks associated with using an Internet based
            currency, including but not limited to, the risk of hardware,
            software and Internet connections, the risk of malicious software
            introduction, and the risk that third parties may obtain
            unauthorized access to information stored within your wallet. You
            accept and acknowledge that Maitrix will not be responsible for any
            communication failures, disruptions, errors, distortions or delays
            you may experience when using the Services for transactions, however
            caused.
            <br />
            <br />
            (e) A lack of use or public interest in the creation and development
            of distributed ecosystems could negatively impact the development of
            those ecosystems and related applications, and could therefore also
            negatively impact the potential utility or value of the Services.
            <br />
            <br />
            (f) The regulatory regime governing blockchain technologies,
            cryptocurrencies, and tokens is uncertain, and new regulations or
            policies may materially adversely affect the development of the
            Services.
            <br />
            <br />
            (g) The Services may rely on third-party platforms to perform
            transactions with respect to any cryptocurrency assets. If we are
            unable to maintain a good relationship with such platform providers;
            if the terms and conditions or pricing of such platform providers
            change; if we violate or cannot comply with the terms and conditions
            of such platforms; or if any of such platforms loses market share or
            falls out of favor or is unavailable for a prolonged period of time,
            access to and use of the Service will suffer.
            <br />
            <br />
            (h) There are risks associated with purchasing user generated
            content, including but not limited to, the risk of purchasing
            counterfeit assets, mislabeled assets, assets that are vulnerable to
            metadata decay, assets on smart contracts with bugs, and assets that
            may become untransferable. Maitrix reserves the right to hide
            collections, contracts, and assets affected by any of these issues
            or by other issues. Assets you purchase may become inaccessible on
            Maitrix. Under no circumstances shall the inability to view or
            access your assets on Maitrix serve as grounds for a claim against
            Maitrix.
            <br />
            <br />
            (i) By accessing and using the Services, you represent that you
            understand the inherent risks associated with using cryptographic
            and blockchain-based systems, and that you have a working knowledge
            of digital assets. Such systems may have vulnerabilities or other
            failures, or other abnormal behavior. Maitrix is not responsible for
            any issues with the Blockchains or other blockchain-based networks,
            including forks, technical node issues or any other issues having
            fund, NFT, or Rewards losses as a result. You acknowledge that the
            cost and speed of transacting with cryptographic and
            blockchain-based systems such as Ethereum are variable and may
            increase at any time. You further acknowledge the risk that your
            digital assets may lose some or all of their value while they are
            supplied to or from the Services. You further acknowledge that we
            are not responsible for any of these variables or risks and cannot
            be held liable for any resulting losses that you experience while
            accessing Services. Accordingly, you understand and agree to assume
            full responsibility for all of the risks of accessing and using and
            interacting with the Services.
            <br />
            <br />
            (j) The regulatory regime governing Artificial Intelligence is
            uncertain, and new regulations or policies may materially adversely
            affect the development of the Services.
            <br />
            <br />
            13. Indemnity.
            <br />
            <br />
            (a) You will indemnify, defend (at Maitrix’ option) and hold Maitrix
            and its officers, directors, employees and agents, harmless from and
            against any claims, disputes, demands, liabilities, damages, losses,
            and costs and expenses, including, without limitation, reasonable
            legal and accounting fees arising out of or in any way connected
            with (a) your access to or use of the Services, (b) your Services
            Content, or (c) your violation of these Terms. You may not settle or
            otherwise compromise any claim subject to this Section without
            Maitrix’ prior written approval.
            <br />
            <br />
            (b) You will indemnify and hold harmless Maitrix and its officers,
            directors, employees and agents, from and against any claims,
            disputes, demands, liabilities, damages, losses, and costs and
            expenses, including, without limitation, reasonable legal and
            accounting fees arising out of or in any way connected with your
            breach of your representations and warranties from Section 5(e)(v).
            <br />
            <br />
            14. Limitation of Liability.
            <br />
            <br />
            (a) TO THE MAXIMUM EXTENT PERMITTED BY LAW, NEITHER MAITRIX NOR ITS
            SERVICE PROVIDERS INVOLVED IN CREATING, PRODUCING, OR DELIVERING THE
            SERVICES WILL BE LIABLE FOR ANY INCIDENTAL, SPECIAL, EXEMPLARY OR
            CONSEQUENTIAL DAMAGES, OR DAMAGES FOR LOST PROFITS, LOST REVENUES,
            LOST SAVINGS, LOST BUSINESS OPPORTUNITY, LOSS OF DATA OR GOODWILL,
            SERVICE INTERRUPTION, COMPUTER DAMAGE OR SYSTEM FAILURE OR THE COST
            OF SUBSTITUTE SERVICES OF ANY KIND ARISING OUT OF OR IN CONNECTION
            WITH THESE TERMS OR FROM THE USE OF OR INABILITY TO USE THE
            SERVICES, WHETHER BASED ON WARRANTY, CONTRACT, TORT (INCLUDING
            NEGLIGENCE), PRODUCT LIABILITY OR ANY OTHER LEGAL THEORY, AND
            WHETHER OR NOT MAITRIX OR ITS SERVICE PROVIDERS HAVE BEEN INFORMED
            OF THE POSSIBILITY OF SUCH DAMAGE, EVEN IF A LIMITED REMEDY SET
            FORTH HEREIN IS FOUND TO HAVE FAILED OF ITS ESSENTIAL PURPOSE. SOME
            JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF LIABILITY
            FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES, SO THE ABOVE LIMITATION MAY
            NOT APPLY TO YOU.
            <br />
            <br />
            (b) TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT WILL THE
            AGGREGATE TOTAL LIABILITY OF MAITRIX AND ITS AGENTS,
            REPRESENTATIVES, AND AFFILIATES ARISING OUT OF OR IN CONNECTION WITH
            THESE TERMS OR FROM THE USE OF OR INABILITY TO USE THE SERVICES
            EXCEED THE AMOUNTS YOU HAVE PAID OR ARE PAYABLE BY YOU TO MAITRIX
            FOR USE OF THE SERVICES OR ONE HUNDRED U.S. DOLLARS ($100), IF YOU
            HAVE NOT HAD ANY PAYMENT OBLIGATIONS TO MAITRIX, AS APPLICABLE.
            <br />
            <br />
            (c) THE EXCLUSIONS AND LIMITATIONS OF DAMAGES SET FORTH ABOVE ARE
            FUNDAMENTAL ELEMENTS OF THE BASIS OF THE BARGAIN BETWEEN MAITRIX AND
            YOU.
            <br />
            <br />
            15. Governing Law and Forum Choice. These Terms and any action
            related thereto will be governed by the United Kingdom law. Except
            as otherwise expressly set forth in Section 16 “Dispute Resolution,”
            the exclusive jurisdiction for all Disputes (defined below) that you
            and Maitrix are not required to arbitrate will be in courts located
            in the United Kingdom, and you and Maitrix each waive any objection
            to jurisdiction and venue in such courts.
            <br />
            <br />
            16. Dispute Resolution.
            <br />
            <br />
            (a) Informal Resolution of Disputes. You and Maitrix must first
            attempt in good faith to resolve any dispute, claim or controversy
            arising out of or relating to these Terms or the breach,
            termination, enforcement, interpretation or validity thereof or the
            use of the Services (collectively, “Disputes”) informally.
            Accordingly, neither you nor Maitrix may start a formal arbitration
            proceeding or file a claim in court for at least sixty (60) days
            after one party notifies the other party of a claim in writing (the
            “Informal Dispute Resolution Period”). As part of this informal
            resolution process, you must deliver your written notices via hand
            or first-class mail to us at Maitrix (the “Notice of Claim”). The
            Notice of Claim shall include both the mailing address and email
            address you would like Maitrix to use to contact you. If Maitrix
            elects to send you a Notice of Claim, it will send, by certified
            mail, a written Notice of Claim to your address on file. A Notice of
            Claim, whether sent by you or by Maitrix, must (a) describe the
            nature and basis of the claim or dispute; and (b) set forth the
            specific amount of damages or other relief sought.
            <br />
            <br />
            (b) Exceptions. Notwithstanding the above and below, each party
            retains the right to seek injunctive or other equitable relief from
            a court to prevent (or enjoin) the infringement or misappropriation
            of that party’s intellectual property rights.
            <br />
            <br />
            (c) Class Action Waiver. YOU AND MAITRIX AGREE THAT EACH MAY BRING
            DISPUTES AGAINST THE OTHER ONLY IN YOUR OR ITS INDIVIDUAL CAPACITY,
            AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS,
            CONSOLIDATED, OR REPRESENTATIVE PROCEEDING. Further, if the parties’
            Dispute is resolved through arbitration, the arbitrator may not
            consolidate another person’s claims with your claims and may not
            otherwise preside over any form of a representative or class
            proceeding. If Maitrix believes that any Dispute you have filed in
            arbitration or in court is inconsistent with the limitations in this
            paragraph, then you agree that Maitrix may seek an order from a
            court determining whether your Dispute is within the scope of the
            Class Action Waiver. If a court or an arbitrator determines that any
            part of this arbitration provision or Class Action Waiver is
            unenforceable with respect to any Dispute, remedy, or request for
            relief, then the arbitration provision and Class Action Waiver will
            not apply to that Dispute, remedy, or request for relief. But the
            arbitration provision and Class Action Waiver will still apply to
            all other Disputes, remedies, and requests for relief that you or
            Maitrix may assert in that or any other action. In any such case,
            you and Maitrix agree that the parties will arbitrate all Disputes,
            remedies, and requests for relief subject to individual arbitration
            first, and that any remaining unresolved Disputes, remedies, or
            requests for relief may be pursued in court only after the
            arbitrator’s award has been issued. In any such proceeding, the
            arbitrator’s factual findings will not be entitled to deference by
            the court. The parties agree that any statutes of limitations
            applicable to the unresolved Disputes, remedies, or requests for
            relief shall be tolled pending the outcome of any individual
            Disputes in arbitration.
            <br />
            <br />
            17. General Terms.
            <br />
            <br />
            (a) Reservation of Rights. Maitrix and its licensors exclusively own
            all rights, title and interest in and to the Services, including all
            associated intellectual property rights. You acknowledge that the
            Services are protected by copyright, trademark, and other laws of
            the United Kingdom and foreign countries. You agree not to remove,
            alter or obscure any copyright, trademark, service mark or other
            proprietary rights notices incorporated in or accompanying the
            Services.
            <br />
            <br />
            (b) Disclosures. You acknowledge and agree that there may be
            circumstances that arise (including related to your purchase or
            selling activities on the Site) which may create actual or potential
            conflicts of interests between your interests and others’ interests,
            including the interests of other users, counterparties, or Maitrix.
            Maitrix maintains a conflicts of interest policy to assist its
            handling of any actual or potential conflicts of interest. If there
            are circumstances where there is an actual or potential conflict of
            interest between yourself and Maitrix, Maitrix will take reasonable
            steps to ensure you are treated fairly. You acknowledge and agree
            that Maitrix and our affiliates have discretion to maintain
            commercial relationships with third parties (including liquidity
            providers or executing dealers). Such third parties may transact
            with you on any purchase or sale activities by you, and Maitrix
            and/or our affiliates may derive financial and other benefits from
            such relationships.
            <br />
            <br />
            (c) Severability. Except for any of the provisions in Section 16(c)
            of these Terms (“Class Action Waiver”), if an arbitrator or court of
            competent jurisdiction decides that any part of these Terms is
            invalid or unenforceable, the other parts of these Terms will still
            apply.
            <br />
            <br />
            (d) Entire Agreement. These Terms constitute the entire and
            exclusive understanding and agreement between Maitrix and you
            regarding the Services, and these Terms supersede and replace all
            prior oral or written understandings or agreements between Maitrix
            and you regarding the Services. If any provision of these Terms is
            held invalid or unenforceable by an arbitrator or a court of
            competent jurisdiction, that provision will be enforced to the
            maximum extent permissible, and the other provisions of these Terms
            will remain in full force and effect. Except where provided by
            applicable law in your jurisdiction, you may not assign or transfer
            these Terms, by operation of law or otherwise, without Maitrix’
            prior written consent. Any attempt by you to assign or transfer
            these Terms absent our consent or your statutory right, without such
            consent, will be null. Maitrix may freely assign or transfer these
            Terms without restriction. Subject to the foregoing, these Terms
            will bind and inure to the benefit of the parties, their successors
            and permitted assigns.
            <br />
            <br />
            (e) Notices. Except as otherwise set forth in Section 18(a), any
            notices or other communications provided by Maitrix under these
            Terms will be given: (i) via email; or(ii) by posting to the
            Services. For notices made by email, the date of receipt will be
            deemed the date on which such notice is transmitted.
            <br />
            <br />
            (f) Waiver of Rights. Maitrix’s failure to enforce any right or
            provision of these Terms will not be considered a waiver of such
            right or provision. The waiver of any such right or provision will
            be effective only if in writing and signed by a duly authorized
            representative of Maitrix. Except as expressly set forth in these
            Terms, the exercise by either party of any of its remedies under
            these Terms will be without prejudice to its other remedies under
            these Terms or otherwise.
            <br />
            <br />
            18. Contact Information. If you have any questions about these Terms
            or the Services, please contact Maitrix at team@arkaine.io
          </p>
        </div>
      </div>
    </GradientBorderRadius>
  );
};

export default TermsOfService;
